<template>
    <div>
        <div id="Article" class="layui-container flex-column">
            <h1 class="h1"><img class="image" src="../assets/img/logo5.png" width="77"/>fswan财务软件系统官网</h1>
            <div class="detail">
                fswan是潮合（海南）科技有限公司开发的一套开源的财务软件系统，系统基于前后端分离的架构，后端采用<b>Java SpringBoot</b>
                + <b>Mysql Mybatis</b>，前端基于当前流行的<b>Element UI</b>。架构包含：后台管理端、后端接口，主要功能包含凭证管理、凭证汇总表、科目余额表、明细账、结
                账、科目管理、初始余额配置、报表计项配置、辅助核算、凭证打印、资产负载表、利润表、现金流量表等常用功能。
                系统还拥有完整的用户角色及权限管理功能，适用于各中小型公司（单位）等各类企业的财务管理运营！
            </div>

            <div class="main-product">

                <div class="product">
                    <img class="image" src="../assets/img/login.jpg"
                         style="border: solid 1px #cccccc;border-radius: 6px;width: 560px">
                </div>

                <div class="app">
                    <div class="show">请前往登录体验：</div>
                    <div class="version-er">
                        <p>
                            地址：<a style="color: #00acac" href="https://admin.fswan.cn/#/login" target="_blank">https://admin.fswan.cn</a>
                        </p>
                        <p>账号：admin</p>
                        <p>密码：123456</p>
                    </div>
                    <div class="version-er2">
                        <p>
                            当前版本：<a style="color: #00acac" href="https://gitee.com/traveler_open/xezzs?_from=gitee_search" target="_blank">v2.1</a>
                        </p>
                        <p>
                            开源仓库：<a style="color: #00acac" href="https://gitee.com/traveler_open/xezzs?_from=gitee_search" target="_blank">码云</a>
                        </p>
                        <p>更新时间：2023-08-06</p>
                    </div>
                </div>

            </div>

            <ul class="flex-row">
                <li class="border-blue">
                    <a target="_blank" href="https://gitee.com/traveler_open/xezzs?_from=gitee_search">开源交流版</a>
                </li>
                <li class="back-white">
                    <a @click="handleToggleTab(0)" class="a-white" style="cursor: pointer">授权商用版</a>
                </li>
            </ul>
            <div class="tips">
                注意：开源版本仅供学习和交流，商用必须购买授权，违者必究！
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "",
        props: {

        },
        methods: {
            handleToggleTab(id) {
                this.$emit('handleToggleTab', id);
            }
        }
    };
</script>










